module.exports = __webpack_public_path__ + "media/time-management_de_ipad_new.397dd14b.mp4";